import React from 'react'
import { Outlet } from 'react-router-dom'
import EmployerNavComponent from './EmployerNavComponent'
import Chatbot from 'views/common/Chatbot';
import { useCommonState } from 'ReusableFunctions/CustomHooks';

const EmployerAuth = () => {
  const employerPageDashboardMenu = ["Home", "Applicants", "Pool"];
  const { chatBotState } = useCommonState();

  return (
    <>
      <EmployerNavComponent dashboadMenus={employerPageDashboardMenu} />
      <Outlet />

      {
        chatBotState?.user_data?.payment_status !== "trialing" ?
          <Chatbot />
          :
          null
      }
    </>
  )
}

export default EmployerAuth